import OfficeEditorInsertImageButton from './OfficeEditorInsertImageButton';

export default OfficeEditorInsertImageButton;